import {
  ApolloClient,
  ApolloProvider,
  InMemoryCache,
  createHttpLink,
} from '@apollo/client'
import { useAuth0 } from '@auth0/auth0-react'
import { createContext } from 'react'
import { setContext } from '@apollo/client/link/context'
import { onError } from '@apollo/client/link/error'
import LoadingPage from './Components/LoadingPage'

export const ClientProvider = createContext()

export default function ApolloWrapper({ children }) {
  const { isAuthenticated, isLoading } = useAuth0()

  if (isLoading) {
    return <LoadingPage />
  }
  return isAuthenticated ? (
    <AuthApollo>{children}</AuthApollo>
  ) : (
    <>
      <AuthApollo>{children}</AuthApollo>
    </>
  )
}
export function AuthApollo({ children }) {
  const { getIdTokenClaims, logout } = useAuth0()

  const httpLink = createHttpLink({
    uri: process.env.REACT_APP_APPSYNC_URIS,
  })
  const authLink = setContext(async (_, { headers }) => {
    // get the authentication token from local storage if it exists

    const idClaims = await getIdTokenClaims()
    const idToken = idClaims.__raw
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        Authorization: idToken,
      },
    }
  })

  const errorLink = onError(({ networkError }) => {
    if (networkError?.statusCode === 401) {
      logout({ returnTo: window.location.origin })
    }
  })

  const client = new ApolloClient({
    link: errorLink.concat(authLink.concat(httpLink)),
    cache: new InMemoryCache(),
  })
  return (
    <ClientProvider.Provider value={client}>
      <ApolloProvider client={client}>{children}</ApolloProvider>
    </ClientProvider.Provider>
  )
}
